import qs from 'qs';
import Api from '../api.ts';

const INVITE_TOKEN = '/invite-tokens';

const InviteTokenAPI = {
  create(data) {
    return Api.post(`${INVITE_TOKEN}`, { data });
  },

  getAll(params) {
    return Api.get(`${INVITE_TOKEN}?${qs.stringify(params)}`);
  },

  refresh(tokenId) {
    return Api.get(`${INVITE_TOKEN}/${tokenId}/refresh`);
  },

  verify(token) {
    return Api.post(`${INVITE_TOKEN}/verify`, { data: { token } });
  },
};

export default InviteTokenAPI;
